import React from 'react';
import StrategyList from './pages/StrategyList';
import StrategyEditor from './pages/StrategyEditor';
import StrategyDetail from './pages/StrategyDetail';
import RunPage from './pages/RunPage';
export { configure } from './api';
export const routes = [
  { path: '/strategies', component: <StrategyList /> },
  { path: '/strategies/new', component: <StrategyEditor /> },
  { path: '/strategies/:id', component: <StrategyDetail /> },
  { path: '/strategies/:id/edit', component: <StrategyEditor /> },
  { path: '/strategies/runs/:id', component: <RunPage /> },
  // Where the settlement centre links an answer.
  { path: '/strategies/predictions/:id', component: <RunPage byPrediction /> },
];
export const navigation = {
  id: 'strategies',
  label: 'My Strategies',
  icon: 'ri-lightbulb-flash-line',
  link: '/strategies'
};
// Private to each member: there is nothing to show a visitor.
export const publicNavigation = null;
export function getNavigation() {
  return { ...navigation, subItems: [
    { id: 'strategies-list', label: 'My strategies', link: '/strategies', parentId: navigation.id },
    { id: 'strategies-new', label: 'New strategy', link: '/strategies/new', parentId: navigation.id },
  ] };
}
